<template>
  <div>
    <div class="template-loader__container">
      <SkeletonLoader show-animation class="template-loader__container--left" />
      <SkeletonLoader
        v-if="isRightLoading"
        show-animation
        class="template-loader__container--right"
      />
    </div>
    <SkeletonLoader show-animation>
      <div class="template-loader__container--main" />
    </SkeletonLoader>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { SkeletonLoader } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    SkeletonLoader
  }
})
export default class MainLoading extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isRightLoading!: boolean;
}
</script>

<style lang="less" scoped>
.template-loader__container {
  display: flex;
  justify-content: space-between;
  margin: @size-spacing-x800 0 @size-spacing-x300 0;
  height: 40px;

  &--right {
    width: 100px;
    background-color: @background-tertiary;
    border-radius: @size-spacing-x600;
  }

  &--left {
    width: 170px;
    background-color: @background-tertiary;
    border-radius: @size-spacing-x600;
  }

  &--main {
    margin: @size-spacing-x800 0 @size-spacing-x300 0;
    width: 100%;
    height: 40px;
    border-radius: 32px;
    background-color: @background-tertiary;
  }
}

.template-loader__container--main {
  @media only screen and (max-height: 650px) {
    height: 166px;
  }

  @media only screen and (min-height: 651px) and (max-height: 720px) {
    height: 206px;
  }

  @media only screen and (min-height: 721px) and (max-height: 899px) {
    height: 296px;
  }

  @media only screen and (min-height: 900px) and (max-height: 999px) {
    height: 396px;
  }

  @media only screen and (min-height: 1000px) and (max-height: 1199px) {
    height: 416px;
  }
}
</style>
